module.exports = __webpack_public_path__ + "media/images/icons/browser-buttons-440636766d42862f77a2324401704958.svg";